/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').
    factory('ReportModel_Resource',["$resource","$location",  "$locale", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + '/datas/reportsList.json' , {} ,
            {
                getReports : {method: 'GET',url:baseUrl+'/datas/reportsList.json',isArray: true},
                getAdvancedReports : {method: 'GET',url:baseUrl+'/datas/advancedReportsList.json',isArray: true},
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ReportModel',["ReportModel_Resource","ReportModelData",
        function (ReportModel_Resource, ReportModelData)
    {

        var ReportModel = function (resource, advanced)
        {
            this.id = null;
            this.title = null;
            this.descriptionTitle = null;
            this.descriptionDetail = null;
            this.index = null;
            this.indexActifEltReport = 0;//default value
            this.eltsReport = [];
            this.advanced = advanced;
            this.onTemplateOnly = false;
            this.businessPage = null;
            this.helpCenterArticles = null;

            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource);
            }
            ReportModelData.add(this);
        };

        ReportModel.prototype.loadObject = function(object)
        {
            this.id = object.id;
            this.title = object.title;
            this.descriptionTitle = object.descriptionTitle;
            this.descriptionDetail = object.descriptionDetail;
            this.index = object.index;
            this.indexActifEltReport = object.indexActifEltReport;//default value
            this.typeOfData = object.typeOfData;
            this.eltsReport = object.eltsReport;
            this.onTemplateOnly = object.onTemplateOnly;
            this.businessPage = object.businessPage;
            this.helpCenterArticles = object.helpCenterArticles;
        };

        return ReportModel;
    }
]);

angular.module('FlexyBeautyApp.services').
    factory('ReportModelSrv',["$log","ReportModel_Resource","ReportModel","ReportModelData",
        function ($log,ReportModel_Resource,ReportModel,ReportModelData)
    {
        var  reportModelSrv =
        {};

        reportModelSrv.query = function(successFunction,errorFunction)
        {
            ReportModel_Resource.getReports(
                {}, //params
                function (data) {   //success

                    for (var i=0;i< data.length;i++)
                        new ReportModel(data[i], false);//Auto Add to ReportModelData

                    if (successFunction!== undefined)
                        successFunction(ReportModelData.indexReportsModel);

                },
                function (data) {   //failure
                    $log.error("ReportModel_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                }
            );

            ReportModel_Resource.getAdvancedReports(
                {}, //params
                function (data) {   //success

                    for (var i=0;i< data.length;i++)
                        new ReportModel(data[i], true);//Auto Add to ReportModelData

                    if (successFunction!== undefined)
                        successFunction(ReportModelData.indexReportsModel);

                },
                function (data) {   //failure
                    $log.error("ReportModel_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                }
            );
        }

        reportModelSrv.loadRef =  function() {
            var reportsModel = ReportModelData.indexReportModelData;
            for (var i = 0; i < reportsModel.length; i++)
                reportsModel[i].loadRef();
        }


        return reportModelSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ReportModelData',["$log", function ($log)
    {
        var  reportModelData =
        {
            indexReportsModel : [],
            deletedReportsModel : []
        };
        reportModelData.getById =  function(reportModelId)
        {
            for (var i=0;i<this.indexReportsModel.length;i++)
                if (this.indexReportsModel[i].id==reportModelId)
                    return this.indexReportsModel[i];
            return null;
        }
        reportModelData.getByIndex =  function(reportModelIndex)
        {
            if (reportModelIndex>=0 && reportModelIndex<this.indexReportsModel.length)
            {
                return this.indexReportsModel[reportModelIndex];
            }
            else
                return null;
        }
        reportModelData.getIndexOf =  function(reportModel)
        {
            if (reportModel)
                return this.indexReportsModel.indexOf(reportModel);
            return -1;
        }
        reportModelData.add =  function(reportModel)
        {
            this.indexReportsModel.push(reportModel);
            if (reportModel.isDeleted)
            {
                var index = this.deletedReportsModel.indexOf(reportModel);
                if (index==-1)
                    this.deletedReportsModel.push(reportModel);
            }
            return this.indexReportsModel.length-1;
        }
        reportModelData.remove =  function(reportModel) //Soft Remove
        {
            var index =  this.deletedReportsModel.indexOf(reportModel);
            if (index==-1)
            {
                this.deletedReportsModel.push(reportModel);
                reportModel.isDeleted=true;
            }

        }
        reportModelData.restore =  function(reportModel) //Soft Remove
        {
            var index =  this.deletedReportsModel.indexOf(reportModel);
            if (index!=-1)
            {
                this.deletedReportsModel.splice(index,1);
                reportModel.isDeleted=false;
            }

        }
        reportModelData.clear =  function()
        {
            reportModelData.indexReportsModel = [];
            reportModelData.deletedReportsModel = [];
        }
        reportModelData.getDeletedList =  function()
        {
            return reportModelData.deletedReportsModel;
        }

        reportModelData.getActiveList =  function()
        {
            return this.indexReportsModel;
        }

        return reportModelData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/ReportModel.js